var styleDataHash = "50204340";
const injectCss = () => {
  var css = `.M9m98{height:18px;position:relative;width:18px}.asiby,.scGQ0{height:100%;position:absolute;top:0;width:100%;fill:none;stroke-linecap:round}[dir=ltr] .asiby,[dir=ltr] .scGQ0{left:0}[dir=rtl] .asiby,[dir=rtl] .scGQ0{right:0}.asiby{stroke:currentColor;opacity:.3}[dir=ltr] .asiby{animation:RSND6 666ms linear infinite}[dir=rtl] .asiby{animation:P2tZQ 666ms linear infinite}.scGQ0{stroke:currentColor}[dir=ltr] .scGQ0{animation:RSND6 2s linear infinite}[dir=rtl] .scGQ0{animation:P2tZQ 2s linear infinite}@keyframes RSND6{to{transform:rotate(1turn)}}@keyframes P2tZQ{to{transform:rotate(-1turn)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var double_loader_default = {
  "wrapper": "M9m98",
  "top": "asiby",
  "bottom": "scGQ0",
  "rotation-ltr": "RSND6",
  "rotation-rtl": "P2tZQ"
};
export {
  double_loader_default as default,
  injectCss
};
//# sourceMappingURL=double-loader-scss.js.map
